export default {
  primary: {
    main: "#00bcd4",
    light: "#26c6da",
    contrastText: "#fff"
  }
};
//# sourceMappingURL=cyan.js.map